import React, { useEffect, useState } from "react";
import APIS from "../../constant/Endpoint";
import { File, Folder, PlusIcon } from "lucide-react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useDebounce } from "../../customHooks/useDebounceHook";
import useGetHook from "../../customHooks/useGetHook";
import { useNavigate } from "react-router-dom";

const Search = (props: any) => {
  const { setOpenSearchPopup } = props;
  const [query, setQuery] = useState("");
  const [results, setResults] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();

  const debouncedSearch = useDebounce(query);

  const { data, isLoading, isRefetching } = useGetHook({
    queryKey: [`search-${debouncedSearch}`],
    url: APIS.SEARCH,
    enabled: debouncedSearch ? true : false,
    params: {
      search: debouncedSearch,
    },
  });

  useEffect(() => {
    if (data) {
      setResults(data);
    }
  }, [data]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
  };

  const handleClear = () => {
    setQuery("");
    setResults(null);
  };

  return (
    <div className={tw`w-[600px] rounded-md p-2 bg-white`}>
      <div className={tw`bg-[#EEF5F4] rounded flex justify-between`}>
        <input
          type="text"
          value={query}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          placeholder="Search here"
          className={tw`w-full p-2 rounded bg-[#EEF5F4] focus:outline-none`}
        />
        {query && (
          <button
            type="button"
            onClick={handleClear}
            className={tw`rotate-45 text-gray-500`}
          >
            <PlusIcon />
          </button>
        )}
      </div>

      <div className={tw`mt-2 min-h-[160px] flex flex-col items-center w-full`}>
        {isLoading || isRefetching ? (
          <ul className={tw`w-full bg-[#DEDEDEC2] p-2`}>
            {[...Array(4)].map((_, index) => (
              <li
                key={index}
                className={tw`animate-pulse bg-gray-300 h-6 my-2 rounded w-full`}
              />
            ))}
          </ul>
        ) : results?.folders?.length === 0 && results?.files?.length === 0 ? (
          <span className={tw`text-gray-500`}>No recent searches</span>
        ) : (
          <ul className={tw`w-full bg-[#DEDEDEC2]`}>
            {Array.isArray(results?.folders) &&
              results.folders.map((item: any) => (
                <li
                  key={item?.id}
                  onClick={() => {
                    setOpenSearchPopup((prev) => !prev);
                    navigate(`folder/${item.id}`);
                  }}
                  className={tw`py-2 px-4 cursor-pointer hover:bg-gray-300 rounded flex border-b items-center gap-x-2`}
                >
                  <Folder />
                  {item?.title}
                </li>
              ))}
            {Array.isArray(results?.files) &&
              results.files.map((item: any) => (
                <li
                  key={item?.id}
                  className={tw`py-2 px-4 cursor-pointer hover:bg-gray-300 rounded flex items-center gap-x-2`}
                >
                  <File />
                  {item?.title}
                </li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Search;
